import LoginRegisterSwitch from './LoginRegisterSwitch';

export default LoginRegisterSwitch;
